import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { Check } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { listItemCheck } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuCheckboxItemIndicatorProps extends PartProps<BaseContextMenu.CheckboxItemIndicator.Props> {
  className?: string
}

function ContextMenuCheckboxItemIndicator({ className, children, ...props }: ContextMenuCheckboxItemIndicatorProps) {
  return (
    <BaseContextMenu.CheckboxItemIndicator
      data-slot="list-item-check"
      className={twMerge(listItemCheck, className)}
      {...props}
    >
      {children ?? <Check />}
    </BaseContextMenu.CheckboxItemIndicator>
  )
}

export { ContextMenuCheckboxItemIndicator }
